webpackJsonp([0],{

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1956)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1930),
  /* template */
  __webpack_require__(1976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b92778e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_grv_services__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_LoteStatus__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_acl_tmp_acl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(13);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'historico-leiloes-grv',
  props: {
    grvId: {
      type: Number,
      default: function _default() {
        return 0;
      },
      required: true
    }
  },
  data: function data() {
    return {
      isLoaded: false,
      historicoLeiloes: [],
      urlLeilao: '/website/leiloes/'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    Status: function Status() {
      return __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_LoteStatus__["Status"];
    },
    ACL: function ACL() {
      return __WEBPACK_IMPORTED_MODULE_4__domain_acl_tmp_acl__["a" /* default */];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['isLogged', 'currentUser'])),
  filters: {
    formatarData: function formatarData(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD/MM/YYYY LT');
    }
  },
  created: function created() {
    this.carregarHistoricoLeiloes();
    console.log(this.$router.currentRoute);
  },

  methods: {
    carregarHistoricoLeiloes: function carregarHistoricoLeiloes() {
      var _this = this;

      if (!this.grvId) {
        alert('Este lote não possui uma grv relacionada');
        this.$emit('close');
        return;
      }
      this.$parent.loading(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__domain_grv_services__["u" /* getHistoricoLeiloesGrv */])(this.grvId).then(function (response) {
        _this.historicoLeiloes = response.data;
      }).catch(function (error) {
        alert('Ocorreu um erro ao carregar o histórico de leilões');
        console.log(error);
      }).finally(function () {
        _this.isLoaded = true;
        _this.$parent.loading(false);
      });
    }
  }
});

/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, "td[data-v-1b92778e]{text-align:center}.informacoes-historico[data-v-1b92778e]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.informacoes-historico span[data-v-1b92778e]{font-weight:700}.resultado-success[data-v-1b92778e]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}", "", {"version":3,"sources":["/home/raphael/work/apl/intranet/src/app/website/leiloes/components/HistoricoLeiloesGrv.vue"],"names":[],"mappings":"AACA,oBACE,iBAAkB,CACnB,AACD,wCACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,6CACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC","file":"HistoricoLeiloesGrv.vue","sourcesContent":["\ntd[data-v-1b92778e] {\n  text-align: center\n}\n.informacoes-historico[data-v-1b92778e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.informacoes-historico span[data-v-1b92778e] {\n  font-weight: bold;\n}\n.resultado-success[data-v-1b92778e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1956:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("258eca6c", content, true, {});

/***/ }),

/***/ 1976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Histórico de leilões")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "informacoes-historico m-b-lg"
  }, [_c('div', [_vm._v("Essa GRV já foi incluída em "), _c('span', [_vm._v(_vm._s(_vm.historicoLeiloes.length))]), _vm._v(" leil" + _vm._s(_vm.historicoLeiloes.length === 1 ? 'ão' : 'ões'))])]), _vm._v(" "), (_vm.historicoLeiloes.length) ? _c('div', [_c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("LEILÃO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("DATA DE ABERTURA")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("NÚMERO DE LOTE")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoLeiloes), function(item) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [(_vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'leiloes.visualizar',
          params: {
            id: item.id
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(item.titulo))])]) : _c('span', [_vm._v("(" + _vm._s(item.titulo) + ")")]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.Status[item.status].titulo) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatarData")(item.dataAbertura.date)))]), _vm._v(" "), _c('td', {
      style: ({
        'color': !item.numeroLote ? 'red' : 'black'
      })
    }, [(_vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: item.id,
            id: item.loteId
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(item.numeroLote || "Não numerado"))])]) : _c('span', [_vm._v("(" + _vm._s(item.numeroLote || "Não numerado") + ")")])], 1)])
  }), 0)])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.53288846f15e15d9cd33.js